export enum PermissibleTypes {
    Taxonomy = 'App\\Modules\\CommonComponents\\Models\\Taxonomy',
}
